<template>
  <header class="ren-decoration-cp ren-decoration-cp-content-article-header">
    <img v-if="showCover && coverUrl" :src="coverUrl" alt="" />
    <strong>{{ title }}</strong>
    <span v-if="showSummary && summary">{{ summary }}</span>
    <small>{{ meta }}</small>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const showCover = computed(() => booleanValue(props.component.props?.showCover, true))
const showSummary = computed(() => booleanValue(props.component.props?.showSummary, true))
const title = computed(() => stringValue(data.value.title, '图文标题'))
const summary = computed(() => stringValue(data.value.summary ?? data.value.subtitle))
const coverUrl = computed(() => widgetMediaUrl(data.value.coverUrl ?? data.value.imageUrl))
const meta = computed(() => {
  const parts: string[] = []
  if (booleanValue(props.component.props?.showPublisher, true) && data.value.publisher) {
    parts.push(String(data.value.publisher))
  }
  if (booleanValue(props.component.props?.showPublishedAt, true) && data.value.publishedAt) {
    parts.push(String(data.value.publishedAt))
  }
  if (booleanValue(props.component.props?.showReadCount, true) && data.value.readCount != null) {
    parts.push(`${data.value.readCount} 阅读`)
  }
  return parts.join(' · ')
})
</script>

<style scoped>
.ren-decoration-cp-content-article-header {
  display: grid;
  gap: 8px;
}
.ren-decoration-cp-content-article-header img {
  width: 100%;
  max-height: 160px;
  object-fit: cover;
}
.ren-decoration-cp-content-article-header span,
.ren-decoration-cp-content-article-header small {
  color: var(--ren-theme-muted);
  font-size: 12px;
}
</style>
